import { useEffect } from 'react';
import { trackPageView } from '../utils/usageTracker';
export function useTrackPageView(args) {
  const {
    screen,
    slug,
    locale
  } = args;
  useEffect(() => {
    trackPageView({
      screen,
      slug,
      locale
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screen, slug]);
}